import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./OrderWrapper.scss";
import { FormattedMessage, injectIntl } from "react-intl";
//Multiple Select
import { path } from "../../../utils/constant";

import { toast } from "react-toastify";
import { addNewOrder } from "../../../services/userService";
class ContactWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      address: "",
      phoneNumber: "",
      message: "",
      quantity: "",
      unitPrice: 148,
      discount: 0,
      serviceCharge: 0,
      deliveryCharge: 0,
      subtotal: 148,
      total: 148,
      models: "",
      isSubmitted: false,
      errors: {
        name: "",
        address: "",
        phoneNumber: "",
        message: "",
        quantity: "",
        models: "",
      },
      modelOptions: [
        { label: "A5", value: "A5" },
        // { label: "M3", value: "M3" },
        // { label: "M0", value: "M0" },
        // { label: "M1", value: "M1" },
      ],
    };
  }

  componentDidMount() {
    this.updateModelByLanguage(this.props.language);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.updateModelByLanguage(this.props.language);
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: { ...prevState.errors, [name]: "" },
    }));
  };

  handlePhoneChange = (value) => {
    this.setState((prevState) => ({
      phoneNumber: value || "",
      errors: { ...prevState.errors, phoneNumber: "" },
    }));
  };

  validateForm = () => {
    const { name, address, phoneNumber, message, models } = this.state;

    const phoneRegexVN =
      /^(?:\+84|0)(3[2-9]|5[6|8|9]|7[0|6-9]|8[1-5]|9[0-9])[0-9]{7}$/;

    const errors = {
      ...(name.trim() ? {} : { name: "order.e1" }),
      ...(address.trim() ? {} : { address: "order.e2" }),
      ...(message.trim() ? {} : { message: "order.e3" }),
      ...(!phoneRegexVN.test(phoneNumber) ? { phoneNumber: "order.e4" } : {}),
      ...(!models || models.length === 0 ? { models: "order.e5" } : {}),
    };

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleSubmit = async () => {
    const { phoneNumber } = this.state;

    const normalizedPhone = phoneNumber.replace(/^\+84/, "0");

    this.setState({ isSubmitted: true });

    const isValid = this.validateForm();

    if (isValid) {
      const payload = {
        models: this.state.models,
        name: this.state.name,
        mobile: normalizedPhone,
        address: this.state.address,
        note: this.state.message,
        status: "pending",
        view: 0,
      };

      try {
        const res = await addNewOrder(payload);

        if (res && res.code === 200) {
          toast.success("Đặt hàng thành công", {
            autoClose: 2000,
            position: "top-right",
          });
          this.props.history.push("/");
        } else {
          toast.error("Đặt hàng thất bại. Vui lòng thử lại.");
        }
      } catch (err) {
        console.error("Submit failed:", err);
        toast.error("Lỗi kết nối đến máy chủ.");
      }
    }
  };

  handleQuantityChange = (e) => {
    const raw = e.target.value;

    if (raw === "" || isNaN(raw)) {
      this.setState((prevState) => ({
        quantity: "",
        subtotal: 0,
        total: 0,
        errors: { ...prevState.errors, quantity: "order.e7" }, // giữ lỗi nếu rỗng
      }));
      return;
    }

    const quantity = parseInt(raw, 10);

    if (quantity < 0) {
      this.setState((prevState) => ({
        errors: { ...prevState.errors, quantity: "order.e8" }, // lỗi nếu số âm (tùy bạn có muốn thêm không)
      }));
      return;
    }

    const { unitPrice, discount, serviceCharge, deliveryCharge } = this.state;

    const subtotal = unitPrice * quantity;
    const total = subtotal - discount + serviceCharge + deliveryCharge;

    this.setState((prevState) => ({
      quantity,
      subtotal,
      total,
      errors: { ...prevState.errors, quantity: "" },
    }));
  };

  updateModelByLanguage(language) {
    let models = "";

    if (language === "en") {
      models = "Machine Anovator A5";
    } else if (language === "vi") {
      models = "Máy Anovator A5";
    }

    this.setState((prevState) => ({
      models,
      errors: { ...prevState.errors, models: "" },
    }));
  }
  render() {
    let hrefDefault = "";
    const { intl } = this.props;
    const { name, address, phoneNumber, message, errors, isSubmitted } =
      this.state;

    return (
      <section className="contact-wrap section-padding">
        <div className="container">
          <div className="row gx-4 d-flex justify-content-center">
            <div className="col-xl-9 col-lg-8 order-xl-1 order-lg-1 order-md-1 order-1">
              <div className="contact-box v1 smb-0">
                <div className="contact-box-title">
                  <h5>
                    <FormattedMessage id="order.a24" />
                  </h5>
                </div>
                <form action="#" className="review-form checkout">
                  <div className="row">
                    {/* //Fullname */}
                    <div className="col-lg-4">
                      <div className="form-group v1 input-name">
                        <input
                          type="text"
                          className={` ${errors.name ? "has-error" : ""}`}
                          id="name"
                          name="name"
                          placeholder={intl.formatMessage({ id: "order.a9" })}
                          value={name}
                          onChange={this.handleChange}
                        />
                        {errors.name && (
                          <p className="error-text">
                            <FormattedMessage id={errors.name} />
                          </p>
                        )}
                      </div>
                    </div>
                    {/* //PhoneNumber */}
                    <div className="col-lg-4">
                      <div className="form-group v1">
                        <PhoneInput
                          international
                          defaultCountry="VN"
                          value={phoneNumber}
                          onChange={this.handlePhoneChange}
                          placeholder={intl.formatMessage({
                            id: "order.a11",
                          })}
                          className={`whatapp ${
                            errors.phoneNumber ? "has-error" : ""
                          }`}
                        />
                        {errors.phoneNumber && (
                          <p className="error-text">
                            <FormattedMessage id={errors.phoneNumber} />
                          </p>
                        )}
                      </div>
                    </div>
                    {/* //Models */}
                    <div className="col-lg-4">
                      <div className="form-group v1 input-model">
                        <input
                          type="text"
                          className={` ${
                            this.state.errors?.models ? "has-error" : ""
                          }`}
                          name="models"
                          value={this.state.models}
                          readOnly
                          // onChange={(e) => {
                          //   this.setState((prevState) => ({
                          //     models: e.target.value,
                          //     errors: { ...prevState.errors, models: "" },
                          //   }));
                          // }}
                        />
                        {isSubmitted && errors.models && (
                          <p className="error-text">
                            <FormattedMessage id={errors.models} />
                          </p>
                        )}
                      </div>
                    </div>
                    {/* //Số lượng */}
                    {/* <div className="col-lg-3">
                      <div className="form-group v1 input-name">
                        <input
                          type="number"
                          name="quantity"
                          id="quantity"
                          min="0"
                          value={this.state.quantity}
                          onChange={this.handleQuantityChange}
                          placeholder={intl.formatMessage({ id: "order.a14" })}
                          className={` ${
                            this.state.errors?.quantity ? "has-error" : ""
                          }`}
                        />
                        {errors.quantity && (
                          <p className="error-text">
                            <FormattedMessage id={errors.quantity} />
                          </p>
                        )}
                      </div>
                    </div> */}
                    {/* //address */}
                    <div className="col-lg-12">
                      <div className="form-group v1 input-adress">
                        <input
                          type="text"
                          className={` ${errors.address ? "has-error" : ""}`}
                          id="address"
                          name="address"
                          placeholder={intl.formatMessage({
                            id: "order.a10",
                          })}
                          value={address}
                          onChange={this.handleChange}
                        />
                        {errors.address && (
                          <p className="error-text">
                            <FormattedMessage id={errors.address} />
                          </p>
                        )}
                      </div>
                    </div>
                    {/* //Models */}
                    {/* <div className="col-lg-4">
                      <Select
                        classNamePrefix="select-model"
                        className={
                          !this.state.errors.models
                            ? "select-model"
                            : "select-model error"
                        }
                        isMulti
                        options={this.state.modelOptions}
                        onChange={(selected) => {
                          this.setState((prevState) => ({
                            models: selected,
                            errors: { ...prevState.errors, models: "" },
                          }));
                        }}
                        value={this.state.models}
                        styles={customStyles}
                        placeholder={intl.formatMessage({
                          id: "order.a13",
                        })}
                      />
                      {isSubmitted && errors.models && (
                        <p className="error-text">
                          <FormattedMessage id={errors.models} />
                        </p>
                      )}
                    </div> */}

                    {/* //message */}
                    <div className="col-lg-12">
                      <div className="form-group v1 input-message">
                        <textarea
                          className={` textarea ${
                            errors.message ? "has-error" : ""
                          }`}
                          rows="3"
                          id="message"
                          name="message"
                          placeholder={intl.formatMessage({
                            id: "order.a12",
                          })}
                          value={message}
                          onChange={this.handleChange}
                        ></textarea>
                        {errors.message && (
                          <p className="error-text">
                            <FormattedMessage id={errors.message} />
                          </p>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-lg-12">
                      <div className="select-gender">
                        <div>
                          <input type="radio" id="test1" name="radio-group" />
                          <label htmlFor="test1">Cash On Delivery</label>
                        </div>
                        <div>
                          <input type="radio" id="test2" name="radio-group" />
                          <label htmlFor="test2">Card Payment</label>
                        </div>
                        <div>
                          <input type="radio" id="test3" name="radio-group" />
                          <label htmlFor="test3">Check Payment</label>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-lg-12">
                      <Link
                        to={hrefDefault.toString()}
                        className="btn v1"
                        onClick={(e) => {
                          this.handleSubmit(e);
                        }}
                      >
                        <FormattedMessage id="order.a15" />
                      </Link>
                      <Link to={path.A5} className="btn v8">
                        <FormattedMessage id="order.a16" />
                      </Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/*<div className="col-xl-3 col-lg-4 order-xl-2 order-lg-2 order-md-2 order-2 pb-1">
              <div className="checkout-details">
                <div className="bill-details active">
                  <h5>
                    <FormattedMessage id="order.a17" />
                  </h5>
                  <div className="bill-item-wrap">
                    <div className="bill-item">
                      <div className="bill-item-name">
                        <p>
                          <FormattedMessage id="order.a23" />
                        </p>
                      </div>
                      <div className="bill-item-price">
                        <span>${this.state.unitPrice.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="subtotal-wrap">
                    <div className="subtotal-item">
                      <div className="subtotal-item-left">
                        <h6>
                          <FormattedMessage id="order.a18" />
                        </h6>
                      </div>
                      <div className="subtotal-item-right">
                        <span>${this.state.subtotal.toFixed(2)}</span>
                      </div>
                    </div>
                    <div className="subtotal-item">
                      <div className="subtotal-item-left">
                        <p>
                          <FormattedMessage id="order.a19" />
                        </p>
                      </div>
                      <div className="subtotal-item-right">
                        <p>$0.00</p>
                      </div>
                    </div>
                    <div className="subtotal-item">
                      <div className="subtotal-item-left">
                        <p>
                          <FormattedMessage id="order.a20" />
                        </p>
                      </div>
                      <div className="subtotal-item-right">
                        <p>$0.00</p>
                      </div>
                    </div>
                    <div className="subtotal-item">
                      <div className="subtotal-item-left">
                        <p>
                          <FormattedMessage id="order.a21" />
                        </p>
                      </div>
                      <div className="subtotal-item-right">
                        <p>$0.00</p>
                      </div>
                    </div>
                  </div>
                  <div className="total-wrap">
                    <h5>
                      <FormattedMessage id="order.a22" />
                    </h5>
                    <span>${this.state.total.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>*/}
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};
const mapDispatchToProps = () => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(ContactWrapper))
);
